module.exports = __webpack_public_path__ + "static/img/history03.1b8b765.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history03.jpg
// module id = 8mxo
// module chunks = 1